import $ from 'jquery';
import Promise from 'bluebird';
import { PopupEditor } from './view';

/**
 * Provide popup editor function based on simple form & schema
 *
 * <br>It enabled functions:
 *   prompt: open a popup editor,  return promise which will be resolved after save & cancel
 *   dismiss: close the editor
 *
 */
let currentEditor = null;

/**
 * close existing popup editor
 *
 * @returns {void} void
 */
export function dismiss() {
  if (currentEditor) {
    currentEditor.trigger('cancel');
  }
}

function clickToDismiss(e) {
  if ($(e.target).closest('.popup-editor').length === 0) {
    dismiss();
  }
}

function removeEditor() {
  if (currentEditor) {
    currentEditor.remove();
    currentEditor = null;
    $(window).off('click', clickToDismiss);
  }
}

/**
 * show popup editor for the provided entity & model & editable fields
 *
 * @param {Object} options - the options for render popup editor, see
 * http://bingadsinternal.azurewebsites.net/sharedcomponents/client/jsdoc/popup-editor/src/view.html for detail
 * Additional option available for this factory is parentContainerSelector. By default,
 * popups will be appeneded to the page body; however, we allow passing a custom
 * parentContainer for the popup.
 *
 * @returns {Promise} promise which will trigger resolve after click or save
 */
export function prompt(options) {
  if (currentEditor) {
    dismiss();
  }

  const parentContainerSelector = options.parentContainerSelector || 'body';

  return new Promise((resolve) => {
    window.setTimeout(() => {
      currentEditor = new PopupEditor(options).render();
      currentEditor.on('save', (model) => {
        resolve(model);
        removeEditor();
      });
      currentEditor.on('cancel', () => {
        resolve(null);
        removeEditor();
      });
      $(parentContainerSelector).append(currentEditor.el);
      $(window).click(clickToDismiss);

      if (typeof options.onPromptRendered === 'function') {
        options.onPromptRendered();
      }
    }, 0);
  });
}
